import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/DropdownMenu';
import { ChevDownIcon, DownloadIcon, DownloadStemsIcon } from '@/components/Icons';
import { useDownloadAudio, useDownloadStemsAudio } from '@/hooks/useDownloadAudio';
import { AudioDetailDto } from '@/service/interface';
import { AudioDto } from '@/service/type';
import { useSubscriptionStore } from '@/state/subsription-store';
import React from 'react';

export const DownloadButtonEllipse: React.FC<{
  audioInfo: AudioDetailDto | AudioDto;
}> = ({ audioInfo }) => {
  const { download } = useDownloadAudio();
  const { downloadStems } = useDownloadStemsAudio();
  const { permission } = useSubscriptionStore();
  return (
    <div className="flex items-center rounded-[4px] bg-[#efeff0] text-jen-content-secondary text-[12px] ">
      <div
        className=" py-[4px] px-[6px] cursor-pointer"
        onClick={() => {
          download(audioInfo);
        }}
      >
        Download
      </div>
      <div className="w-[1px] h-[26px] bg-jen-background-primary"></div>
      <DropdownMenu>
        <DropdownMenuTrigger className="outline-none">
          <ChevDownIcon className="cursor-pointer" fillColor="currentColor" />
        </DropdownMenuTrigger>
        <DropdownMenuContent className=" bg-jen-background-primary ">
          {/* <DropdownMenuLabel>My Account</DropdownMenuLabel> */}
          {/* <DropdownMenuSeparator /> */}
          <DropdownMenuItem
            className="cursor-pointer"
            onClick={() => {
              download(audioInfo);
            }}
          >
            <DownloadIcon className="mr-[4px]" fillColor="currentColor" /> Download Track
          </DropdownMenuItem>
          <DropdownMenuItem
            className="cursor-pointer"
            onClick={() => {
              downloadStems(audioInfo);
            }}
            disabled={permission.downloadStems === null}
          >
            <DownloadStemsIcon className="mr-[4px]" fillColor="currentColor" /> Download Stems
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
